import axios from 'axios'; 
import router from '../router';   
    
    const state = {
        // users state
        lastBarcode: [],
    };
    
    const mutations = {
        setLastBarcode(state, barcode) {
            state.lastBarcode = Array.isArray(barcode) ? barcode : [barcode];
        },
    };

    const getters = {
        getLastBarcode: (state) => state.lastBarcode[0]?.barcode || null,
    };
    
    const actions = {
        /*
        async fetchLastGeneratedBarcode({ commit }) {
            const userToken = localStorage.getItem('userToken'); 
            if (!userToken) {
                // Redirect to login page if token is not found
                router.push({ name: 'login' });
                return;
            }

            const response = await axios.get('https://api.datafangst.dk/api/barcodes', { headers: { Authorization: `Bearer ${userToken }` }, } );
            commit('setLastBarcode', response.data.barcode);
        },
        */
        async fetchLastGeneratedBarcode({ commit }) {
            const userToken = localStorage.getItem('userToken'); 
            if (!userToken) {
                console.log('No user token found, redirecting to login');
                router.push({ name: 'login' });
                return;
            }

            try {
                console.log('Fetching barcodes from API...');
                const response = await axios.get('https://api.datafangst.dk/api/barcodes', { 
                    headers: { Authorization: `Bearer ${userToken}` } 
                });
                
                if (response.data && response.data.barcode && Array.isArray(response.data.barcode) && response.data.barcode.length > 0 && response.data.barcode[0].barcode) {
                    console.log('Fetched barcode data:', response.data.barcode[0].barcode);
                    commit('setLastBarcode', response.data.barcode);
                } else {
                    console.error('Invalid response format:', response.data);
                    throw new Error('Invalid response format');
                }
            } catch (error) {
                console.error('Error fetching last barcode:', error);
                commit('setLastBarcode', []); // Set to empty array if there's an error
                throw error; // Re-throw the error to be caught in the component
            }
        },

        async updateBarcode({ dispatch }, { prodnr, barcode })  {
            const userToken = localStorage.getItem('userToken'); 
            if (!userToken) {
                // Redirect to login page if token is not found
                router.push({ name: 'login' });
                return;
            }

            await axios.put(`https://api.datafangst.dk/api/barcodes/${prodnr}`, { barcode }, { headers: { Authorization: `Bearer ${userToken }` }, } );
            dispatch('fetchLastGeneratedBarcode'); // Refresh the last barcode
        },
    };
        
    export default {
        namespaced: true,
        state,
        mutations,
        actions,
        getters
    };